<template>
<section class="banner">
  <!--工具条-->
  <div v-show="isBanner">
    <el-col :span="24" class="toolbar pad_left">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <p style="margin: 0;margin-left: -22px;" class="goodslist1">
          <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </p>
        <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div style="padding:0px 12px" v-show="show3">
        <el-form :inline="true" class="findform" :model="filters" style="margin-top:10px;display:flex">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:100%" label="关键词语：">
            <el-input  v-model="filters.name" placeholder="请输入订单号码"></el-input>
          </el-form-item>
          <el-form-item style="display:flex;width:100%" label="打款状态："  class="select">
            <el-select
              v-model="filters.statusId"
              placeholder="已打款"
              style="background:#fff;"
              ref="mySelect"
            >
              <el-option
                :label="item.Name"
                :value="item.Id"
                v-for="(item,index) in statusoptions"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="display:flex;width:100%" label="下单时间：" class="sub_chaxun">
            <!-- <el-date-picker
                type="date"
                :editable = "false"
                class="normal_width"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                v-model="filters.date1"
                style="width: 100%;"
                :picker-options="pickerOptions"
              ></el-date-picker>
        
            <span class="line till" >至</span>
              <el-date-picker
              class="normal_width"
                placeholder="选择时间"
                v-model="filters.date2"
                :editable = "false"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
            ></el-date-picker>-->
            <el-date-picker
            :title="value6"
              v-model="value6"
              :editable="iseditable"
              style="cursor:pointer;width:100%"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              @change="changetime"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
          
          <el-button style="border-color: none;height:36px;line-height:1px" class="toolbar_search" @click="onSubmit">查询</el-button>
      
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="danger" @click="onSubmit" class="toolbar_search">查询</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    </el-col>
    <template>
      <el-col :span="24" class="main_container pad_left" style="margin-top:10px">
        <section class="model_section" style="display:flex;width:100%">
          <el-col :span="18" style = "width:100%">
            <p class="model_top_title" style="width:58px">结算管理</p>
              <span style="margin-right:33px;border-radius: 4px;width:76px;display:inline-block" class="daochu" @click="showWatch()" v-if="menuAction.indexOf(1064)>-1">导出Excel</span>
          </el-col>
          
        </section>
        <div class="table_container">
          <div class="table_inner_container">
            <el-table
              :data="users"
              v-loading="listLoading"
              class="ban_tab"
              stripe
              border
            style="max-height:500px"
              :header-cell-style="{background:'#bbbbbb'}"
            >
              <el-table-column prop="num" label="序号" align="center" width="50">
                <template scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="OrderNo" label="订单编号" align="center" width="190">
                <template scope="scope">
                  <span
                    :title="scope.row.OrderNo"
                    :label="scope.row.OrderNo"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.OrderNo}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="PayTypeTime" label="支付时间" align="center" width="190">
                <template scope="scope">
                  <span
                    :title="scope.row.PayTypeTime"
                    :label="scope.row.PayTypeTime"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.PayTypeTime}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="PaidPrice" label="原始金额" align="center" width="150">
                <template scope="scope">
                  <span
                    :title="'￥'+scope.row.PaidPrice"
                    :label="scope.row.PaidPrice"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >￥{{scope.row.PaidPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="CostPrice" label="平台扣除佣金" align="center" width="190">
                <template scope="scope">
                  <span
                    :title="'￥'+scope.row.CostPrice"
                    :label="scope.row.CostPrice"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >￥{{scope.row.CostPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="BackPrice" label="付款金额" align="center" width="170">
                <template scope="scope">
                  <span
                    :title="'￥'+scope.row.BackPrice"
                    :label="scope.row.BackPrice"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >￥{{scope.row.BackPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="SettlementTypeName" label="付款类型" align="center" width="170">
                <template scope="scope">
                  <span
                    :title="scope.row.SettlementTypeName"
                    :label="scope.row.SettlementTypeName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.SettlementTypeName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="OrderStatusName" label="订单状态" align="center" width="170">
                <template scope="scope">
                  <span
                    :title="scope.row.OrderStatusName"
                    :label="scope.row.OrderStatusName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.OrderStatusName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="BrandName" label="付款商户" align="center" width="209">
                <template scope="scope">
                  <span
                    :title="scope.row.BrandName"
                    :label="scope.row.BrandName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.BrandName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="BrandNo" label="付款账号" align="center" width="183">
                <template scope="scope">
                  <span
                    :title="scope.row.BrandNo"
                    :label="scope.row.BrandNo"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.BrandName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="StatusName" label="状态" align="center" width="110">
                <template scope="scope">
                  <span
                    :title="scope.row.StatusName"
                    :label="scope.row.StatusName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.StatusName}}</span>
                </template>
                <!-- <template slot-scope="scope">
                  <span :class="{'red':scope.row.operation=='未打款'}">{{scope.row.operation}}</span>
                </template>-->
              </el-table-column>
              <el-table-column prop="CTime" label="付款时间" align="center" width="200">
                <template scope="scope">
                  <span
                    :title="scope.row.CTime"
                    :label="scope.row.CTime"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.CTime}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="150" align="center">
                <template slot-scope="scope">
                  <span class="handle"
                    v-if="menuAction.indexOf(1063)>-1"
                    @click="showAdd(scope.row.Id)">
                    <i class="el-icon-edit-outline"></i>结算</span>
                </template>
              </el-table-column>
            </el-table>
                    <el-col :span="24" style="padding-top:10px"  class="toolbar_footer">
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="total"
            :current-page="pageIndex"
            style="float:right;"
          ></el-pagination>
        </el-col>
            <el-dialog title="提示" :visible.sync="dialogFormVisible" width="30%">
              <el-form :model="form">
                <el-form-item label="已打款">
                  <el-select v-model="region" placeholder="已打款">
                    <el-option label="已打款" value="shanghai"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button
                  class="button2"
                  style="margin-left:-80px;"
                  type="primary"
                  @click="makesure()"
                >确 定</el-button>
                <el-button class="button1" @click="dialogFormVisible = false">取 消</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </el-col>
    </template>
  </div>
</section>
</template>
<script>
import util from "../../common/util";
import NProgress from "nprogress";
import { jiesuan, jeisuanbianji, removeUser, editUser, addUser } from "../../api/api";
export default {
  props: ["menuAction"],
  data() {
    return {
      region: "已打款",
      id: "",
      dialogFormVisible: false,
      filters: {
        name: "",
        statusId: 0,
        date1: "",
        date2: ""
      },
      value6: "",
      users: [],
      total: 1,
      page: 1,
      listLoading: false,
      editFormVisible: false, //编辑界面显是否显示
      form: {
        options: "",
        remark: ""
      },
      // banner是否显示
      isBanner: true,
      show3:true,
      iseditable: false,
      // 新增页面
      isAdd: false,
      isImg: true,
      src1: require("../../assets/img/aicon10.png"),
      src2: require("../../assets/img/aicon13.png"),
      pageIndex: 1,
      pageSize: 10,
      operId: localStorage.Id,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      statusoptions: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "未打款"
        },
        {
          Id: 2,
          Name: "已打款"
        }
      ]
    };
  },
  methods: {
    changetime() {
         if(this.value6+""=="null"){
           this.value6 = ["",""]
      }
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    handleClose() {
      this.dialogFormVisible = false;
    },
    makesure() {
      this.dialogFormVisible = false;
      var bianji = {
        id: this.id,
        oper: localStorage.Id
      };
      jeisuanbianji(bianji).then(({ data }) => {
        this.$swal({
          type: "success",
          text:"操作成功"
        });
        this.getorder();
      });
    },
    //导出
    showWatch() {
      let that = this;
      var addParams = [
        {
          name: "key",
          value: that.filters.name
        },
        {
          name: "statusId",
          value: that.filters.statusId
        },
        {
          name: "startTime",
          value: this.filters.date1
        },
        {
          name: "endTime",
          value: this.filters.date2
        },
        {
          name: "userId",
          value: localStorage.Id
        }
      ];
      var url = "/order/SettlementManage/ExportToExcel";
      this.downLoad(url, addParams);
    },
    checkImg() {
      this.isImg = !this.isImg;
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        statusId: 0,
        date1: "",
        date2: ""
      },
      this.value6 = '';
      // this.pageIndex = 1;
      // this.getorder();
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.getorder();
    },
    showAdd(id) {
      this.id = id;
      this.isBanner = true;
      this.$swal({
        type:"warning",
        text:"重要信息,您确定执行打款操作么?",
        showCancelButton:true,
          cancelButtonText: '取消',
          confirmButtonText: '确定',
      }).then((res)=>{
        if(res.value){
          this.makesure()
        }
      })
    },
    showBan() {
      this.isBanner = true;
      this.isAdd = false;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    },

    //删除
    handleDel: function(row) {
      var _this = this;
      this.$confirm("确认删除该记录吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          _this.listLoading = true;
          NProgress.start();
          let para = { id: row.id };
          removeUser(para).then(res => {
            _this.listLoading = false;
            NProgress.done();
            this.$swal({
              text:"删除成功",
              type:"successs"
            })
            _this.getUsers();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function(row) {
      this.editFormVisible = true;
      this.editFormTtile = "编辑";
      this.editForm.id = row.id;
      this.editForm.name = row.name;
      this.editForm.sex = row.sex;
      this.editForm.age = row.age;
      this.editForm.birth = row.birth;
      this.editForm.addr = row.addr;
    },
    //编辑 or 新增
    editSubmit: function() {
      var _this = this;

      _this.$refs.editForm.validate(valid => {
        if (valid) {
          _this.$confirm("确认提交吗？", "提示", {}).then(() => {
            _this.editLoading = true;
            NProgress.start();
            _this.btnEditText = "提交中";

            if (_this.editForm.id == 0) {
              //新增
              let para = {
                name: _this.editForm.name,
                sex: _this.editForm.sex,
                age: _this.editForm.age,
                birth:
                  _this.editForm.birth == ""
                    ? ""
                    : util.formatDate.format(
                        new Date(_this.editForm.birth),
                        "yyyy-MM-dd"
                      ),
                addr: _this.editForm.addr
              };
              addUser(para).then(res => {
                _this.editLoading = false;
                NProgress.done();
                _this.btnEditText = "提 交";
                this.$swal({
                  text:"提交成功",
                  type:"successs"
                })
                _this.editFormVisible = false;
                _this.getUsers();
              });
            } else {
              //编辑
              let para = {
                id: _this.editForm.id,
                name: _this.editForm.name,
                sex: _this.editForm.sex,
                age: _this.editForm.age,
                birth:
                  _this.editForm.birth == ""
                    ? ""
                    : util.formatDate.format(
                        new Date(_this.editForm.birth),
                        "yyyy-MM-dd"
                      ),
                addr: _this.editForm.addr
              };
              editUser(para).then(res => {
                _this.editLoading = false;
                NProgress.done();
                _this.btnEditText = "提 交";
                 this.$swal({
                  text:"提交成功",
                  type:"successs"
                })
                _this.editFormVisible = false;
                _this.getUsers();
              });
            }
          });
        }
      });
    },
    //显示新增界面
    handleAdd: function() {
      var _this = this;
      this.editFormVisible = true;
      this.editFormTtile = "新增";

      this.editForm.id = 0;
      this.editForm.name = "";
      this.editForm.sex = 1;
      this.editForm.age = 0;
      this.editForm.birth = "";
      this.editForm.addr = "";
    },
    //获取结算
    getorder() {
      let that = this;
      var addParams = {
        userId: this.operId,
        key: that.filters.name,
        statusId: that.filters.statusId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        startTime: that.filters.date1,
        endTime: that.filters.date2
      };
      jiesuan(addParams).then(data => {
        this.total = data.RowsCount;
        this.users = data.ResultObj;
      });
    }
  },
  mounted() {
    this.getorder();
  }
};
</script>

<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.button1 {
  background: #fff;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.button2 {
  background: #fff;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.button1:hover {
  background: #F56C6C;
  color: #fff;
}
.button2:hover {
  background: #F56C6C;
  color: #fff;
}
.red {
  color: #F56C6C;
}
.daochu {
  display: inline-block;
  background: #F56C6C;
  width: 76px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  margin-top: 10px;
  /* margin-left: 34px; */
  float:right;
}
.banner .toolbar {
  height: auto;
}

.toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}
/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  position: relative;
  /* overflow: hidden;
   */
}
/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}

/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.ban_tab p {
  float: left;
  color: #b2b2b2;
  width: 30%;
}
/* .ban_tab p img{
  margin-top:10px
} */
.ban_tab p:first-child {
  margin-left: 10%;
}

/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  height: 801px;
  position: relative;
}
.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.add_banner .el-col-24 p {
  width: 110px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 20px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
</style>




// WEBPACK FOOTER //
// settle.vue?3adb3918